import { NgModule,  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentRouteModule } from './appointment-route.module';

@NgModule({
  imports: [
    CommonModule,
    AppointmentRouteModule
  ],
  declarations: [],
  providers:[]
})
export class AppointmentModule { }



// WEBPACK FOOTER //
// ./src/app/section/appointment/appointment-route/appointment.module.ts